
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router";
import InvestorCards from "./InvestorCards";
import InvestorNavBarMain from "./InvestorNavBar";
import InvestorSideNavBar from "./SideNavBarInvestor";
import Cookies from 'js-cookie';

window.Buffer = window.Buffer || require("buffer").Buffer;
const InvestmentOpportunities = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(()=>{
    if (Cookies.get("User_Accesstoken_Investor") == null) {
      navigate('/');
    }
  },[])
  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <InvestorSideNavBar />

      <main style={{ width: "100%" }}>
        <InvestorNavBarMain
          investorname={"Investor Name" || <Skeleton count={1} />}
        />

        <div className="">
          <div className="row px-4 gap-2  db_body">
            
            <InvestorCards setloading={setLoading} />
            <div className="disclaimer-message">Disclaimer: The borrower/issuer and the information provided have not been reviewed or
            approved by the CBB for crowdfunding offers</div>
          </div>
        </div>
      </main>
    </div>
  );
};
export default InvestmentOpportunities;
